import { render, staticRenderFns } from "./CampaignCommissions.vue?vue&type=template&id=7b81e665"
import script from "./CampaignCommissions.vue?vue&type=script&lang=js"
export * from "./CampaignCommissions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports